// extracted by mini-css-extract-plugin
module.exports = {"container":"p0","square":"p1","slide":"p2","show":"p3"};